/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrgExtScanSessionRequestModel } from '../../models/org-ext-scan-session-request-model';
import { SessionResponseModel } from '../../models/session-response-model';

export interface OrgExtRequestSessionOrganizationIdPersonIdPost$Params {
  organizationId: string;
  personId: string;
      body?: OrgExtScanSessionRequestModel
}

export function orgExtRequestSessionOrganizationIdPersonIdPost(http: HttpClient, rootUrl: string, params: OrgExtRequestSessionOrganizationIdPersonIdPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<SessionResponseModel>> {
  const rb = new RequestBuilder(rootUrl, orgExtRequestSessionOrganizationIdPersonIdPost.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('personId', params.personId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<SessionResponseModel>;
    })
  );
}

orgExtRequestSessionOrganizationIdPersonIdPost.PATH = '/OrgExt/RequestSession/{organizationId}/{personId}';
